import { defineComponent as _defineComponent } from 'vue'
import HyreProfileApprovedIcon from '@/assets/img/HyreProfileApprovedIcon.svg'
import HyreApprovedBadge from '@/assets/img/HyreApprovedBadge.svg'
import { components } from '~/types/generated/schema'
import { computed, useRouter } from '@nuxtjs/composition-api'


export default /*#__PURE__*/_defineComponent({
  __name: 'HyreApprovedModal',
  props: {
    onboardingInfo: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  onboardingInfo: components['schemas']['GetTalentOnboardingInfoResponse']
};



const checklist = computed(() => props.onboardingInfo.checklist!)



const router = useRouter()

const step = computed(() => {
  if (!props.onboardingInfo.checklist?.didMatching) return 'finished-matching'
  else if (!props.onboardingInfo.checklist?.didCompleteExtendedProfile)
    return 'did-extended-profile'
  else return 'started-matching'
})

function onCtaClick() {
  let path: { path: string; query?: any } | undefined
  if (!props.onboardingInfo.checklist?.didMatching) {
    path = { path: '/complete-profile', query: { pageId: props.onboardingInfo.nextWizardPage } }
  } else if (!props.onboardingInfo.checklist?.didCompleteExtendedProfile) {
    path = { path: '/create-profile', query: { pageId: props.onboardingInfo.nextWizardPage } }
  }

  emit('close')
  if (path) router.push(path)
}

return { __sfc: true,props, checklist, emit, router, step, onCtaClick, HyreProfileApprovedIcon, HyreApprovedBadge }
}

})